<template>
  <MainContent>
    <b-card>
      <h3 class="py-4">
        <b>{{$t('faq')}}</b>
        <div class="float-right">
          <b-button class="bd-button" @click="redirectLogin">
            {{$t('back')}}
          </b-button>
        </div>
      </h3>
      <b-tabs pills
        active-nav-item-class="bd-tabs-active" v-model="active" :no-key-nav="true">
        <b-tab :title="$t('faqOverview')"><FaqOverview /></b-tab>
        <b-tab :title="$t('faqRegistration')"><FaqUser /></b-tab>
        <b-tab :title="$t('faqSigning')"><FaqSigning /></b-tab>
        <b-tab :title="$t('faqForms')"><FaqForms /></b-tab>
        <b-tab :title="$t('faqFile')"><FaqFile /></b-tab>
        <b-tab :title="$t('faqWorkspace')"><FaqWorkspace /></b-tab>
        <b-tab :title="$t('faqStorage')"><FaqStorage /></b-tab>
        <b-tab :title="$t('faqSystem')"><FaqSystem /></b-tab>
        <b-tab :title="$t('faqOther')"><FaqOther /></b-tab>
        <b-tab :title="$t('faqError')"><FaqError /></b-tab>
        <b-tab :title="$t('faqHelp')"><FaqSupport /></b-tab>
        <!-- <b-tab :title="$t('faqEDrive')"><FaqEDrive /></b-tab> -->
      </b-tabs>
    </b-card>
  </MainContent>
</template>

<script>
import MainContent from "../../../components/main/MainContent";
import FaqOverview from "../components/FaqOverview";
import FaqUser from "../components/FaqUser";
import FaqSigning from "../components/FaqSigning";
import FaqForms from "../components/FaqForms";
import FaqFile from "../components/FaqFile";
import FaqWorkspace from "../components/FaqWorkspace";
import FaqStorage from "../components/FaqStorage";
import FaqSystem from "../components/FaqSystem";
import FaqOther from "../components/FaqOther";
import FaqError from "../components/FaqError";
import FaqSupport from "../components/FaqSupport";
import FaqEDrive from "../components/FaqEDrive";

export default {
  components: {
    MainContent,
    FaqOverview,
    FaqUser,
    FaqSigning,
    FaqForms,
    FaqFile,
    FaqWorkspace,
    FaqStorage,
    FaqSystem,
    FaqOther,
    FaqError,
    FaqSupport,
    FaqEDrive
  },
  mounted() {
    // 创建 MutationObserver 实例
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {

            const elements = document.querySelectorAll('ul[role="tablist"]');
            elements.forEach(el => {
              if (el.hasAttribute('role')) {
                el.removeAttribute('role');
              }
            });

            // 获取所有 role="tab" 的 <a> 标签
            const tabs = document.querySelectorAll('a[role="tab"]');
            // 修改 role 属性值为 "button"
            tabs.forEach((tab) => {
              tab.setAttribute('role', 'button');
            });

            // 查找 class="nav-pills" 的 ul 标签
            const navPillsElement = document.querySelector('ul.nav-pills');
            if (navPillsElement) {
              // 查找 ul 下的所有 a 标签
              const anchorElements = navPillsElement.querySelectorAll('a');
              // 获取 ul 下的所有 li 子标签
              const liElements = navPillsElement.querySelectorAll('li');
              // 遍历每个 li 元素并删除 role 属性
              liElements.forEach((li) => {
                li.removeAttribute('role');
              });
              // 遍历每个 a 标签并处理
              anchorElements.forEach((anchor) => {
                // 移除不支持的 ARIA 属性
                anchor.removeAttribute('aria-selected');
                anchor.removeAttribute('aria-setsize');
                anchor.removeAttribute('aria-posinset');
                // 如果需要，可以添加正确的 ARIA 属性
                // anchor.setAttribute('role', 'tab'); // 示例：设置语义为“tab”
              });

              navPillsElement.childNodes.forEach((node) => {
                if (node.nodeType === 8) {
                  navPillsElement.removeChild(node);
                }
              });
            }

        }
      })

    });
    // 开始监听 DOM 变化
    observer.observe(document.body, {
      childList: true, // 监听子节点的变化
      subtree: true,   // 监听后代节点
    });
    // 组件销毁时停止监听
    this.$once('hook:beforeDestroy', () => {
      observer.disconnect();
    });
  },
  data(){
    return {
      active: 0,
    }
  },
  methods: {
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    },
  }
};
</script>

<style lang="scss" scoped>
.main-title {
  display: flex;
  justify-content: center;
  text-align: center;
}

/* Underline links inside FAQ content (including v-html). */
::v-deep .faq a {
  text-decoration: underline;
  text-underline-offset: 2px;
}

::v-deep .faq a:hover,
::v-deep .faq a:focus {
  text-decoration-thickness: 2px;
}

::v-deep .card-header {
    background-color: transparent;
    .nav {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        font-weight: bold;
        font-size: 1.25rem;
    }
}
</style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/public/locales/modules/faq/views/FAQView.json" />